export default "__VITE_ASSET__lWRhQpVb__"